<template>
  <div class="filters-panel">
    <div class="field">
      <label class="label">Номер рейса</label>
      <input
        class="input"
        :value="trip_id"
        @input="onTripId"
        placeholder="ID, номер площадки или UID"
        type="text"
      />
    </div>

    <div class="field field-status">
      <label class="label">Статус торгов</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleStatusDropdown">
          <span>{{ statusSummary }}</span><span class="chevron">{{ openStatus ? '\u25B2' : '\u25BC' }}</span>
        </button>
        <div v-if="openStatus" :key="'sd-' + statusKey" class="dropdown-menu">
          <label class="dropdown-option">
            <input type="checkbox" :checked="status.length === 0" :disabled="status.length === 0" @change="selectAllStatuses" />
            <span>Все статусы</span>
          </label>
          <label v-for="opt in statusOptions" :key="opt.value" class="dropdown-option" @click="handleStatusClick($event, opt.value)">
            <input type="checkbox" :checked="status.length === 0 || status.includes(opt.value)" :disabled="status.length === 1 && status.includes(opt.value)" @change="toggleStatus(opt.value)" />
            <span :class="['status-dot', `dot-${opt.value.toLowerCase()}`]"></span>
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
      <div v-if="selectedStatusOptions.length > 1 && !isAllStatuses" class="tag-list">
        <button v-for="opt in selectedStatusOptions" :key="opt.value" class="tag" @click="removeStatus(opt.value)">{{ opt.label }} x</button>
      </div>
    </div>

    <div class="field">
      <label class="label">Победитель</label>
      <select class="input select" :value="winner" @change="onWinner">
        <option v-for="opt in winnerOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </select>
    </div>

    <div class="field field-source">
      <label class="label">Платформа</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleSourceDropdown">
          <span>{{ sourceSummary }}</span><span class="chevron">{{ openSource ? '\u25B2' : '\u25BC' }}</span>
        </button>
        <div v-if="openSource" :key="'pd-' + sourceKey" class="dropdown-menu">
          <label class="dropdown-option">
            <input type="checkbox" :checked="source.length === 0" @change="selectAllSources" />
            <span>Все платформы</span>
          </label>
          <label v-for="opt in sourceOptions" :key="opt.value" class="dropdown-option" @click="handleSourceClick($event, opt.value)">
            <input type="checkbox" :checked="source.length === 0 || source.includes(opt.value)" :disabled="source.length === 1 && source.includes(opt.value)" @change="toggleSource(opt.value)" />
            <span>{{ opt.label }}</span>
          </label>
        </div>
      </div>
      <div v-if="source.length > 1" class="tag-list">
        <button v-for="opt in selectedSourceOptions" :key="opt.value" class="tag" @click="removeSource(opt.value)">{{ opt.label }} x</button>
      </div>
    </div>

    <div class="divider" />

    <div class="field field-from">
      <label class="label">Город отправления</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleFromDropdown">
          <span>{{ citySummary(fromPoints, 'Все города отправления') }}</span><span class="chevron">{{ openFrom ? '\u25B2' : '\u25BC' }}</span>
        </button>
        <div v-if="openFrom" class="dropdown-menu city-menu">
          <input class="input city-search" :value="fromQuery" @input="onFromPointInput" placeholder="Поиск города" type="text" />
          <div class="hint">Показаны первые 30 городов</div>
          <label class="dropdown-option" :class="{ disabled: !fromOptions.length }">
            <input type="checkbox" :checked="allFromVisibleSelected" :disabled="!fromOptions.length" @change="toggleAllFromVisible" />
            <span>{{ fromQuery ? 'Выбрать найденные' : 'Выбрать видимые' }}</span>
          </label>
          <div class="options-list">
            <label v-for="opt in fromOptions" :key="optionValue(opt)" class="dropdown-option">
              <input type="checkbox" :checked="fromPoints.includes(optionValue(opt))" @change="toggleFromPoint(optionValue(opt))" />
              <span class="option-text">{{ optionLabel(opt) }}</span>
              <span class="count">{{ opt.count }}</span>
            </label>
            <div v-if="!fromOptions.length" class="empty-options">Нет вариантов</div>
          </div>
        </div>
      </div>
      <div v-if="fromPoints.length" class="tag-list">
        <button v-for="pt in fromPoints" :key="pt" class="tag" @click="removeFromPoint(pt)">{{ pt }} x</button>
      </div>
    </div>

    <div class="field field-to">
      <label class="label">Город прибытия</label>
      <div class="select-area">
        <button class="dropdown-summary" type="button" @click="toggleToDropdown">
          <span>{{ citySummary(toPoints, 'Все города прибытия') }}</span><span class="chevron">{{ openTo ? '\u25B2' : '\u25BC' }}</span>
        </button>
        <div v-if="openTo" class="dropdown-menu city-menu">
          <input class="input city-search" :value="toQuery" @input="onToPointInput" placeholder="Поиск города" type="text" />
          <div class="hint">Показаны первые 30 городов</div>
          <label class="dropdown-option" :class="{ disabled: !toOptions.length }">
            <input type="checkbox" :checked="allToVisibleSelected" :disabled="!toOptions.length" @change="toggleAllToVisible" />
            <span>{{ toQuery ? 'Выбрать найденные' : 'Выбрать видимые' }}</span>
          </label>
          <div class="options-list">
            <label v-for="opt in toOptions" :key="optionValue(opt)" class="dropdown-option">
              <input type="checkbox" :checked="toPoints.includes(optionValue(opt))" @change="toggleToPoint(optionValue(opt))" />
              <span class="option-text">{{ optionLabel(opt) }}</span>
              <span class="count">{{ opt.count }}</span>
            </label>
            <div v-if="!toOptions.length" class="empty-options">Нет вариантов</div>
          </div>
        </div>
      </div>
      <div v-if="toPoints.length" class="tag-list">
        <button v-for="pt in toPoints" :key="pt" class="tag" @click="removeToPoint(pt)">{{ pt }} x</button>
      </div>
    </div>

    <div class="divider" />

    <div class="field">
      <label class="label">Дата создания от</label>
      <input class="input" type="date" :value="loadingDateFrom" @input="onDateFrom" />
    </div>

    <div class="field">
      <label class="label">Дата создания до</label>
      <input class="input" type="date" :value="loadingDateTo" @input="onDateTo" />
    </div>

    <div class="date-presets-block">
      <span class="presets-title">Быстрый выбор периода</span>
      <div class="chip-group date-presets">
        <button
          v-for="preset in datePresets"
          :key="preset.label"
          :class="['chip', 'preset-chip', { active: preset.active }]"
          @click="applyPreset(preset)"
        >{{ preset.label }}</button>
      </div>
    </div>

    <div class="divider" />

    <div class="field">
      <label class="label">Тип ТС</label>
      <select class="input select" :value="vehicleType" @change="onVehicleType">
        <option value="">Все типы ТС</option>
        <option value="TENT">TENT</option>
        <option value="ISO">ISO</option>
        <option value="REF">REF</option>
        <option value="TANK">TANK</option>
      </select>
    </div>

    <div class="field">
      <label class="label">Задача</label>
      <select class="input select" :value="tasked" @change="onTasked">
        <option v-for="opt in taskedOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </select>
    </div>

    <div class="field field-checkbox">
      <label class="checkbox-label">
        <input type="checkbox" :checked="hazardous" @change="onHazardous" />
        <span>Опасный груз</span>
      </label>
    </div>

    <button class="btn-clear" @click="clearAll">Сбросить фильтры</button>
  </div>
</template>

<script>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { BIDDING_STATES, SOURCE_OPTIONS, TASKED_OPTIONS, WINNER_OPTIONS } from '../helpers';

function formatDate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getMonday(d) {
  const date = new Date(d);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  return date;
}

function getLastDayOfMonth(year, month) {
  return new Date(year, month + 1, 0);
}

export default {
  name: 'PureBiddingFilters',
  setup() {
    const store = useStore();
    const state = computed(() => store.state.pureBidding);
    const openStatus = ref(false);
    const openSource = ref(false);
    const openFrom = ref(false);
    const openTo = ref(false);
    const statusKey = ref(0);
    const sourceKey = ref(0);
    const fromQuery = ref('');
    const toQuery = ref('');
    const fromOptions = ref([]);
    const toOptions = ref([]);

    const statusOptions = BIDDING_STATES;
    const sourceOptions = SOURCE_OPTIONS;
    const taskedOptions = TASKED_OPTIONS;
    const winnerOptions = WINNER_OPTIONS;

    const toggleStatusDropdown = () => {
      openStatus.value = !openStatus.value;
      if (openStatus.value) statusKey.value++;
    };
    const toggleSourceDropdown = () => {
      openSource.value = !openSource.value;
      if (openSource.value) sourceKey.value++;
    };

    const datePresets = computed(() => {
      const from = state.value.loadingDateFrom;
      const to = state.value.loadingDateTo;
      const today = new Date();
      const now = formatDate(today);

      const d = new Date();
      d.setDate(d.getDate() + 1);
      const tomorrow = formatDate(d);

      const d2 = new Date();
      d2.setDate(d2.getDate() + 2);
      const afterTomorrow = formatDate(d2);

      const dMinus = new Date();
      dMinus.setDate(dMinus.getDate() - 1);
      const yesterday = formatDate(dMinus);

      const monday = getMonday(today);
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);
      const thisWeek = { from: formatDate(monday), to: formatDate(sunday) };

      const prevMonday = new Date(monday);
      prevMonday.setDate(monday.getDate() - 7);
      const prevSunday = new Date(prevMonday);
      prevSunday.setDate(prevMonday.getDate() + 6);
      const prevWeek = { from: formatDate(prevMonday), to: formatDate(prevSunday) };

      const nextMonday = new Date(monday);
      nextMonday.setDate(monday.getDate() + 7);
      const nextSunday = new Date(nextMonday);
      nextSunday.setDate(nextMonday.getDate() + 6);
      const nextWeek = { from: formatDate(nextMonday), to: formatDate(nextSunday) };

      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = getLastDayOfMonth(today.getFullYear(), today.getMonth());
      const thisMonth = { from: formatDate(firstDay), to: formatDate(lastDay) };

      const plus3 = new Date();
      plus3.setDate(plus3.getDate() + 3);
      const minus3 = new Date();
      minus3.setDate(minus3.getDate() - 3);

      const presets = [
        { label: 'Сегодня', range: { from: now, to: now } },
        { label: 'Завтра', range: { from: tomorrow, to: tomorrow } },
        { label: 'Послезавтра', range: { from: afterTomorrow, to: afterTomorrow } },
        { label: 'Вчера', range: { from: yesterday, to: yesterday } },
        { label: 'Тек. неделя', range: thisWeek },
        { label: 'Прош. неделя', range: prevWeek },
        { label: 'След. неделя', range: nextWeek },
        { label: 'Тек. месяц', range: thisMonth },
        { label: '+3 дня', range: { from: now, to: formatDate(plus3) } },
        { label: '-3 дня', range: { from: formatDate(minus3), to: now } },
      ];

      return presets.map((p) => ({
        ...p,
        active: from === p.range.from && to === p.range.to,
      }));
    });

    const applyPreset = (preset) => {
      const from = state.value.loadingDateFrom;
      const to = state.value.loadingDateTo;
      if (from === preset.range.from && to === preset.range.to) {
        store.dispatch('pureBidding/setLoadingDateRange', { from: '', to: '' });
        return;
      }
      store.dispatch('pureBidding/setLoadingDateRange', preset.range);
    };

    const sourceValues = SOURCE_OPTIONS.map((o) => o.value);
    const statusValues = BIDDING_STATES.map((o) => o.value);

    const normalizeSourceValue = (nextValue) => {
      if (nextValue.length === sourceValues.length && sourceValues.every((item) => nextValue.includes(item))) {
        store.dispatch('pureBidding/setSource', []);
        return;
      }
      store.dispatch('pureBidding/setSource', nextValue);
    };

    const toggleSource = (val) => {
      const cur = state.value.source;
      const currentValue = cur.length === 0 ? sourceValues : cur;
      const next = currentValue.includes(val) ? currentValue.filter((v) => v !== val) : [...currentValue, val];
      if (next.length > 0) normalizeSourceValue(next);
    };

    const handleSourceClick = (event, val) => {
      if (!event.shiftKey) return;
      event.preventDefault();
      event.stopPropagation();
      store.dispatch('pureBidding/setSource', [val]);
    };

    const normalizeStatusValue = (nextValue) => {
      if (nextValue.length === 0) return;
      if (nextValue.length === statusValues.length && statusValues.every((item) => nextValue.includes(item))) {
        store.dispatch('pureBidding/setStatus', []);
        return;
      }
      store.dispatch('pureBidding/setStatus', nextValue);
    };

    const toggleStatus = (val) => {
      const cur = state.value.status;
      const currentValue = cur.length === 0 ? statusValues : cur;
      const next = currentValue.includes(val) ? currentValue.filter((v) => v !== val) : [...currentValue, val];
      normalizeStatusValue(next);
    };

    const handleStatusClick = (event, val) => {
      if (!event.shiftKey) return;
      event.preventDefault();
      event.stopPropagation();
      store.dispatch('pureBidding/setStatus', [val]);
    };

    const selectAllStatuses = () => store.dispatch('pureBidding/setStatus', []);
    const selectAllSources = () => store.dispatch('pureBidding/setSource', []);
    const removeStatus = (val) => {
      const cur = state.value.status.length === 0 ? statusValues : state.value.status;
      const next = cur.filter((item) => item !== val);
      if (next.length > 0) normalizeStatusValue(next);
    };
    const removeSource = (val) => {
      const cur = state.value.source.length === 0 ? sourceValues : state.value.source;
      const next = cur.filter((item) => item !== val);
      if (next.length > 0) normalizeSourceValue(next);
    };

    const normalizeOption = (value) => (typeof value === 'string' ? value : value?.value || value?.label || value?.city_name || '');
    const optionValue = (option) => normalizeOption(option);
    const optionLabel = (option) => (typeof option === 'string' ? option : option?.label || option?.value || option?.city_name || '');
    const citySummary = (items, placeholder) => (items.length === 1 ? items[0] : items.length > 1 ? `Выбрано: ${items.length}` : placeholder);

    const loadFromOptions = (q) => store.dispatch('pureBidding/getCityOptions', { kind: 'departure', q })
      .then((items) => { fromOptions.value = items || []; });

    const loadToOptions = (q) => store.dispatch('pureBidding/getCityOptions', { kind: 'destination', q })
      .then((items) => { toOptions.value = items || []; });

    const toggleFromDropdown = () => {
      openFrom.value = !openFrom.value;
      if (openFrom.value && fromOptions.value.length === 0) loadFromOptions(undefined);
    };

    const toggleToDropdown = () => {
      openTo.value = !openTo.value;
      if (openTo.value && toOptions.value.length === 0) loadToOptions(undefined);
    };

    const toggleFromPoint = (value) => {
      const city = normalizeOption(value).trim();
      if (!city) return;
      const current = state.value.fromPoints;
      const next = current.includes(city) ? current.filter((item) => item !== city) : [...current, city];
      store.dispatch('pureBidding/setFromPoints', next);
    };

    const toggleToPoint = (value) => {
      const city = normalizeOption(value).trim();
      if (!city) return;
      const current = state.value.toPoints;
      const next = current.includes(city) ? current.filter((item) => item !== city) : [...current, city];
      store.dispatch('pureBidding/setToPoints', next);
    };

    const toggleAllFromVisible = () => {
      const visible = fromOptions.value.map(optionValue).filter(Boolean);
      if (!visible.length) return;
      const current = state.value.fromPoints;
      const allSelected = visible.every((item) => current.includes(item));
      store.dispatch('pureBidding/setFromPoints', allSelected
        ? current.filter((item) => !visible.includes(item))
        : [...new Set([...current, ...visible])]);
    };

    const toggleAllToVisible = () => {
      const visible = toOptions.value.map(optionValue).filter(Boolean);
      if (!visible.length) return;
      const current = state.value.toPoints;
      const allSelected = visible.every((item) => current.includes(item));
      store.dispatch('pureBidding/setToPoints', allSelected
        ? current.filter((item) => !visible.includes(item))
        : [...new Set([...current, ...visible])]);
    };

    let fromTimer = null;
    const onFromPointInput = (e) => {
      clearTimeout(fromTimer);
      const val = e.target.value;
      fromQuery.value = val;
      fromTimer = setTimeout(() => {
        if (!val.trim()) {
          fromOptions.value = [];
          return;
        }
        loadFromOptions(val);
      }, 300);
    };

    let toTimer = null;
    const onToPointInput = (e) => {
      clearTimeout(toTimer);
      const val = e.target.value;
      toQuery.value = val;
      toTimer = setTimeout(() => {
        if (!val.trim()) {
          toOptions.value = [];
          return;
        }
        loadToOptions(val);
      }, 300);
    };

    const removeFromPoint = (pt) => {
      store.dispatch('pureBidding/setFromPoints', state.value.fromPoints.filter((v) => v !== pt));
    };
    const removeToPoint = (pt) => {
      store.dispatch('pureBidding/setToPoints', state.value.toPoints.filter((v) => v !== pt));
    };

    let tripTimer = null;
    const onTripId = (e) => {
      clearTimeout(tripTimer);
      const val = e.target.value;
      tripTimer = setTimeout(() => {
        store.dispatch('pureBidding/setTripId', val);
      }, 500);
    };

    const onDateFrom = (e) => store.dispatch('pureBidding/setLoadingDateFrom', e.target.value);
    const onDateTo = (e) => store.dispatch('pureBidding/setLoadingDateTo', e.target.value);
    const onVehicleType = (e) => store.dispatch('pureBidding/setVehicleType', e.target.value);
    const onHazardous = (e) => store.dispatch('pureBidding/setHazardous', e.target.checked);
    const onTasked = (e) => store.dispatch('pureBidding/setTasked', e.target.value);
    const onWinner = (e) => store.dispatch('pureBidding/setWinner', e.target.value);

    const clearAll = () => store.dispatch('pureBidding/clearFilters');

    const handleClickOutside = (e) => {
      if (openStatus.value && !e.target.closest('.field-status')) openStatus.value = false;
      if (openSource.value && !e.target.closest('.field-source')) openSource.value = false;
      if (openFrom.value && !e.target.closest('.field-from')) openFrom.value = false;
      if (openTo.value && !e.target.closest('.field-to')) openTo.value = false;
    };

    onMounted(() => window.addEventListener('click', handleClickOutside));
    onBeforeUnmount(() => window.removeEventListener('click', handleClickOutside));

    return {
      trip_id: computed(() => state.value.trip_id),
      source: computed(() => state.value.source),
      statusKey,
      sourceKey,
      fromQuery,
      toQuery,
      fromOptions,
      toOptions,
      openStatus,
      openSource,
      openFrom,
      openTo,
      status: computed(() => state.value.status),
      winner: computed(() => state.value.winner),
      vehicleType: computed(() => state.value.vehicleType),
      hazardous: computed(() => state.value.hazardous),
      tasked: computed(() => state.value.tasked),
      fromPoints: computed(() => state.value.fromPoints),
      toPoints: computed(() => state.value.toPoints),
      loadingDateFrom: computed(() => state.value.loadingDateFrom),
      loadingDateTo: computed(() => state.value.loadingDateTo),
      isAllStatuses: computed(() => state.value.status.length === 0 || statusValues.every((item) => state.value.status.includes(item))),
      selectedStatusOptions: computed(() => state.value.status.length === 0 ? BIDDING_STATES : BIDDING_STATES.filter((o) => state.value.status.includes(o.value))),
      selectedSourceOptions: computed(() => SOURCE_OPTIONS.filter((o) => state.value.source.includes(o.value))),
      allFromVisibleSelected: computed(() => fromOptions.value.length > 0 && fromOptions.value.map(optionValue).every((item) => state.value.fromPoints.includes(item))),
      allToVisibleSelected: computed(() => toOptions.value.length > 0 && toOptions.value.map(optionValue).every((item) => state.value.toPoints.includes(item))),
      statusSummary: computed(() => {
        if (!state.value.status.length) return 'Все статусы';
        if (state.value.status.length === 1) return BIDDING_STATES.find((o) => o.value === state.value.status[0])?.label || '';
        return `Выбрано: ${state.value.status.length}`;
      }),
      sourceSummary: computed(() => {
        if (!state.value.source.length) return 'Все платформы';
        if (state.value.source.length === 1) return SOURCE_OPTIONS.find((o) => o.value === state.value.source[0])?.label || state.value.source[0];
        return `Выбрано: ${state.value.source.length}`;
      }),
      statusOptions,
      sourceOptions,
      taskedOptions,
      winnerOptions,
      datePresets,
      applyPreset,
      toggleSource,
      handleSourceClick,
      selectAllSources,
      removeSource,
      toggleStatus,
      toggleStatusDropdown,
      toggleSourceDropdown,
      handleStatusClick,
      selectAllStatuses,
      removeStatus,
      optionValue,
      optionLabel,
      citySummary,
      toggleFromDropdown,
      toggleToDropdown,
      onFromPointInput,
      onToPointInput,
      toggleFromPoint,
      toggleToPoint,
      toggleAllFromVisible,
      toggleAllToVisible,
      removeFromPoint,
      removeToPoint,
      onTripId,
      onDateFrom,
      onDateTo,
      onVehicleType,
      onHazardous,
      onTasked,
      onWinner,
      clearAll,
    };
  },
};
</script>

<style scoped>
.filters-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  font-size: 14px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 2px;
}

.input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background: #fff;
  color: #333;
  box-sizing: border-box;
}

.input.select { cursor: pointer; }

.select-area { position: relative; }

.dropdown-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  min-height: 18px;
  box-sizing: border-box;
  gap: 6px;
}

.chevron {
  flex-shrink: 0;
  color: #007bff;
  font-size: 12px;
}

.dropdown-menu {
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  top: calc(100% + 4px);
  max-height: 220px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid #d7dce2;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.12);
  user-select: none;
}

.city-menu {
  max-height: 340px;
}

.city-search {
  margin-bottom: 6px;
  box-sizing: border-box;
  width: 100%;
}

.hint {
  margin-bottom: 4px;
  color: #888;
  font-size: 12px;
}

.options-list {
  display: flex;
  flex-direction: column;
  max-height: 180px;
  overflow-y: auto;
  background: #fff;
  border: 0;
  border-radius: 0;
}

.dropdown-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.dropdown-option:hover { background: rgba(224, 187, 72, 0.18); }
.dropdown-option input { accent-color: #007bff; }

.dropdown-option.disabled {
  color: #999;
  cursor: default;
}

.option-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.count,
.empty-options {
  color: #888;
  font-size: 12px;
}

.empty-options {
  padding: 8px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.dot-play { background: #007bff; }
.dot-won { background: #28a745; }
.dot-lost { background: #dc3545; }
.dot-not_participated { background: #6c757d; }
.dot-annulled { background: #868e96; }
.dot-canceled { background: #fd7e14; }
.dot-deleted { background: #343a40; }
.dot-unknown { background: #adb5bd; }
.dot-done { background: #17a2b8; }
.dot-tender { background: #6f42c1; }

.chip-group { display: flex; flex-wrap: wrap; gap: 4px; }

.chip {
  padding: 3px 8px;
  border: 1px solid #ccc;
  border-radius: 12px;
  font-size: 13px;
  background: #fff;
  color: #333;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.chip.active { background: #007bff; border-color: #007bff; color: #fff; }
.chip:hover { border-color: #007bff; }

.date-presets-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f7f8fa;
}

.presets-title { font-size: 13px; font-weight: 600; color: #555; }

.tag-list { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }

.tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 6px;
  border: 1px solid #007bff;
  border-radius: 10px;
  font-size: 12px;
  cursor: pointer;
  color: #007bff;
  background: #e8f0fe;
  line-height: 1.4;
}

.divider { height: 1px; background: #e5e7eb; }

.field-checkbox { flex-direction: row; align-items: center; }

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-label input { accent-color: #007bff; }

.btn-clear {
  padding: 6px 12px;
  border: 1px solid #b83235;
  border-radius: 4px;
  background: #fff;
  color: #b83235;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-clear:hover { background: #b83235; color: #fff; }
</style>
